import styled, { css } from 'styled-components';
import { getBreakpoint } from '$util/theme/breakpoints';

export const nutHeaderSrc = 'https://res.cloudinary.com/fxtr/image/upload/landing/nut-header_ruvzu1.svg';

export const topBackgroundCss = css`
  @media (min-width: ${getBreakpoint('md')}) {
    background: url(${nutHeaderSrc}) no-repeat center 100%;
    background-position: 50% -10%;
    min-height: 600px;
  }
  @media (min-width: ${getBreakpoint('lg')}) {
    background-position: 50% 35%;
  }
`;

export default styled.section`
  ${topBackgroundCss}
`;
